// 后端基址 —— 【唯一事实源】。
//
// 【为什么要有它】(2026-09-25)
//   在此之前,后端域名 `https://log-inter.wuxiahaojie.com` 被【逐字写死在 9 个 .vue 里、
//   共 16 处】。后果不是"不好看",是三件具体的事:
//     · 换机器 / 换域名 / 上正式服,要在 16 个地方逐个改,漏一处就是"大部分页面好用、
//       个别页面还在打旧机器" —— 而且页面不会报错,只是数据不对;
//     · 本地开发没法指向本地后端,只能改源码,改完还容易误提交;
//     · 前后端分离部署时,同源/跨域策略调不了。
//
// 【怎么配】
//   构建期由 .env.development / .env.production 的 VUE_APP_LOG_API 决定。
//   ⚠️Vue CLI 的环境变量是【构建期】注入的,不是运行期 —— 换地址要重新 build,
//     不能只改服务器上的文件。部署脚本必须把 build 和配置绑在一起。
export const LOG_API = process.env.VUE_APP_LOG_API || 'https://log-inter.wuxiahaojie.com';

export default LOG_API;
